import { supabase } from "@/integrations/supabase/client";

export interface RegistrationCheckInput {
  full_name?: string;
  email?: string;
  phone?: string;
  company_name?: string;
  organization_number?: string;
}

export interface RegistrationCheckResult {
  full_name_taken?: boolean;
  email_taken?: boolean;
  phone_taken?: boolean;
  company_name_taken?: boolean;
  organization_number_taken?: boolean;
}

/**
 * Checks the database for already-used registration fields.
 * Returns a map of taken flags. Throws on RPC error.
 */
export async function checkRegistrationAvailability(
  input: RegistrationCheckInput,
): Promise<RegistrationCheckResult> {
  const { data, error } = await supabase.rpc("check_registration_availability", {
    _full_name: input.full_name ?? null,
    _email: input.email ?? null,
    _phone: input.phone ?? null,
    _company_name: input.company_name ?? null,
    _organization_number: input.organization_number ?? null,
  } as any);
  if (error) throw error;
  return (data ?? {}) as RegistrationCheckResult;
}

/**
 * Returns the first user-facing Swedish error message for any taken field,
 * or null if everything is available.
 */
export function firstTakenErrorMessage(r: RegistrationCheckResult): string | null {
  if (r.email_taken) return "E-postadressen används redan av ett annat konto.";
  if (r.organization_number_taken) return "Organisationsnumret är redan registrerat.";
  if (r.company_name_taken) return "Företagsnamnet används redan av ett annat konto.";
  if (r.phone_taken) return "Telefonnumret används redan av ett annat konto.";
  if (r.full_name_taken) return "Namnet används redan av ett annat konto.";
  return null;
}
